export default __webpack_public_path__ + "static/11-5fbcd2860eabdeb41b764adda0531c30.jpg";